import React, { useEffect, useState } from "react";
import { vehiculosService } from "../services/api";
import { Card, Table, Form, Button, Pagination, InputGroup, Badge, Modal } from "react-bootstrap";
import { FaSearch, FaPlus, FaEdit, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const PAGE_SIZE = 8;

const VehiculosList = () => {
  const [vehiculos, setVehiculos] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [orderBy, setOrderBy] = useState(1);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ page: 1, limit: PAGE_SIZE, total: 0, pages: 1 });
  const [confirmDelete, setConfirmDelete] = useState({ show: false, id: null, label: '' });
  const navigate = useNavigate();

  useEffect(() => {
    fetchVehiculos();
    // eslint-disable-next-line
  }, [page, orderBy]);

  const fetchVehiculos = async () => {
    setLoading(true);
    try {
      const res = await vehiculosService.buscar({ search, page, limit: PAGE_SIZE, orderBy });
      setVehiculos(res.data.vehiculos || []);
      if (res.data.pagination) setPagination(res.data.pagination);
    } catch (e) {
      setVehiculos([]);
      setPagination({ page: 1, limit: PAGE_SIZE, total: 0, pages: 1 });
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setPage(1);
    fetchVehiculos();
  };

  const handleOrder = (colIdx) => {
    setOrderBy(colIdx);
    setPage(1);
  };

  return (
    <Card className="mt-4">
      <Card.Header className="d-flex justify-content-between align-items-center">
        <h4>Vehículos</h4>
        <Button variant="success" className="d-flex align-items-center gap-2" onClick={() => navigate('/vehiculo-detail')}>
          <FaPlus /> Añadir vehículo
        </Button>
      </Card.Header>
      <Card.Body>
        <Form onSubmit={handleSearch} className="mb-3">
          <InputGroup>
            <Form.Control placeholder="Buscar por matrícula, tipo o transportista..." value={search} onChange={(e) => setSearch(e.target.value)} />
            <Button type="submit" variant="primary"><FaSearch /></Button>
          </InputGroup>
        </Form>

        <div className="d-none d-md-block">
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th onClick={() => handleOrder(1)} style={{ cursor: 'pointer' }}>MATRÍCULA</th>
                <th onClick={() => handleOrder(3)} style={{ cursor: 'pointer' }}>TIPO</th>
                <th>TRANSPORTISTA</th>
                <th onClick={() => handleOrder(5)} style={{ cursor: 'pointer' }}>FIN SEGURO</th>
              </tr>
            </thead>
            <tbody>
              {vehiculos.length === 0 && (
                <tr><td colSpan={4} className="text-center">No hay vehículos</td></tr>
              )}
              {vehiculos.map((v) => (
                <tr key={v.ID}>
                  <td>{v.MATRICULA}</td>
                  <td>{v.TIPO_VEHICULO}</td>
                  <td>{v.TRANSPORTISTA || '-'}</td>
                  <td>{v.FECHA_FIN_SEGURO ? new Date(v.FECHA_FIN_SEGURO).toLocaleDateString('es-ES') : '-'}</td>
                  <td style={{ width: 130 }}>
                    <div className="d-flex gap-2">
                      <Button size="sm" variant="outline-primary" title="Editar" onClick={() => navigate(`/vehiculo-detail?vehiculo_id=${v.ID}`)}>
                        <FaEdit />
                      </Button>
                      <Button size="sm" variant="outline-danger" title="Eliminar" onClick={() => setConfirmDelete({ show: true, id: v.ID, label: v.MATRICULA })}>
                        <FaTrash />
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>

        <div className="d-md-none">
          {vehiculos.length === 0 ? (
            <div className="text-center py-4">No hay vehículos</div>
          ) : (
            <div className="gastos-cards">
              {vehiculos.map((v) => (
                <Card key={v.ID} className="mb-3">
                  <Card.Body>
                    <div className="d-flex justify-content-between align-items-start mb-2">
                      <div className="flex-grow-1">
                        <h6 className="mb-1">{v.MATRICULA}</h6>
                        <small className="text-muted">{v.TIPO_VEHICULO}</small>
                      </div>
                    </div>
                    <div className="row g-2 mb-2">
                      <div className="col-6">
                        <small className="text-muted d-block">Transportista:</small>
                        <span>{v.TRANSPORTISTA || '-'}</span>
                      </div>
                      <div className="col-6">
                        <small className="text-muted d-block">Fin seguro:</small>
                        <span>{v.FECHA_FIN_SEGURO ? new Date(v.FECHA_FIN_SEGURO).toLocaleDateString('es-ES') : '-'}</span>
                      </div>
                    </div>
                    <div className="d-flex flex-wrap gap-2 mt-2">
                      <Button variant="outline-primary" size="sm" onClick={() => navigate(`/vehiculo-detail?vehiculo_id=${v.ID}`)} title="Editar">
                        <FaEdit />
                      </Button>
                      <Button variant="outline-danger" size="sm" onClick={() => setConfirmDelete({ show: true, id: v.ID, label: v.MATRICULA })} title="Eliminar">
                        <FaTrash />
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              ))}
            </div>
          )}
        </div>
        <Modal show={confirmDelete.show} onHide={() => setConfirmDelete({ show: false, id: null, label: '' })} centered>
          <Modal.Header closeButton>
            <Modal.Title>Eliminar vehículo</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            ¿Seguro que deseas eliminar el vehículo "{confirmDelete.label}"? Esta acción marcará el registro como inactivo.
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setConfirmDelete({ show: false, id: null, label: '' })}>Cancelar</Button>
            <Button
              variant="danger"
              onClick={async () => {
                try {
                  await vehiculosService.delete(confirmDelete.id);
                  setConfirmDelete({ show: false, id: null, label: '' });
                  fetchVehiculos();
                } catch (e) {
                  setConfirmDelete({ show: false, id: null, label: '' });
                }
              }}
            >
              Eliminar
            </Button>
          </Modal.Footer>
        </Modal>

        {pagination.pages > 1 && (
          <div className="d-flex justify-content-center mt-3">
            <Pagination>
              <Pagination.First onClick={() => setPage(1)} disabled={pagination.page === 1} />
              <Pagination.Prev onClick={() => setPage((p) => Math.max(1, p - 1))} disabled={pagination.page === 1} />
              {Array.from({ length: pagination.pages }, (_, i) => i + 1).map((n) => (
                <Pagination.Item key={n} active={n === pagination.page} onClick={() => setPage(n)}>{n}</Pagination.Item>
              ))}
              <Pagination.Next onClick={() => setPage((p) => Math.min(pagination.pages, p + 1))} disabled={pagination.page === pagination.pages} />
              <Pagination.Last onClick={() => setPage(pagination.pages)} disabled={pagination.page === pagination.pages} />
            </Pagination>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default VehiculosList;


